function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useEffect } from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
import isCallable from '../../_snowpack/pkg/is-callable.js';
export function useOnOutsideClick({
  onOutsideClick,
  ref
}) {
  useEffect(() => {
    const outsideClickHandler = new ListenForOutsideClick({
      getElement: () => ref === null || ref === void 0 ? void 0 : ref.current,
      onClickOutside: onOutsideClick
    });
    outsideClickHandler.start();
    return () => outsideClickHandler.stop();
  }, [onOutsideClick, ref]);
}
export function OutsideClick({
  onOutsideClick,
  children,
  ...rest
}) {
  const ref = useRef();
  useOnOutsideClick({
    onOutsideClick,
    ref
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref
  }), children);
}
OutsideClick.propTypes = {
  onOutsideClick: PropTypes.func.isRequired
};
export default class ListenForOutsideClick {
  constructor(props) {
    _defineProperty(this, "listening", false);

    _defineProperty(this, "stop", () => {
      if (this.listening) {
        document.body.removeEventListener('click', this.onBodyClick);
        this.listening = false;
      }
    });

    _defineProperty(this, "onBodyClick", evt => {
      const element = this.props.getElement();

      function clickedElementIsInside(el) {
        if (!el) {
          return false;
        }

        if (el === element) {
          return true;
        }

        if (el === document.body) {
          return false;
        }

        return clickedElementIsInside(el.parentElement);
      }

      if (element && !clickedElementIsInside(evt.target)) {
        const {
          onClickOutside
        } = this.props;

        if (isCallable(onClickOutside)) {
          onClickOutside();
        }
      }
    });

    this.props = props;
  }

  start() {
    if (!this.listening) {
      document.body.addEventListener('click', this.onBodyClick, false);
      this.listening = true;
    }
  }

}